
export class UnitToSearch {
  public id: number;
  public title: string | null;

  constructor(id: number, title: string | null) {
    this.id = id;
    this.title = title;
  }
}